import React from 'react'

import { BasicForm } from '../../../../core/components/form'
import { usePostForm } from '../../../../hooks/manager/project'

import { useHistory } from 'react-router-dom'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'
import { LAYOUT_MANAGER_CLIENT_SHOW } from '../../navigation'

import Form, { ValidationSchema } from './form'

const Formulario = () => {
  const create = usePostForm()
  const history = useHistory()

  const onPressBack = () => history.goBack()

  function handleSubmit (values, bag) {
    const form = { ...values }

    create.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        const { id } = data
        if (id) {
          return history.push(LAYOUT_MANAGER_CLIENT_SHOW(id))
        } else {
          onPressBack()
        }
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const initialValues = {
    code: '',
    name: '',
    description: '',
    client: null,
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    skype: '',
    satisfaction_survey: ''
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='ADD PROJECT'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={(formik) => (
        <Form formik={formik} />
      )}
    />
  )
}

export default Formulario
